import type {
  PaymentType,
  PaymentRequestType,
  ValidateMerchantResponse,
  ValidateMerchantRequest,
} from 'types';

import { ecomApi as api } from '../ecomApi';

export const paymentService = api.injectEndpoints({
  endpoints: (build) => ({
    getData: build.query<PaymentType, { url: string; params: string }>({
      query: (data) => ({
        url: `${data.url}${data.params}&json`,
        method: 'POST',
      }),
    }),
    getCert: build.query<JsonWebKey, null>({
      query: () => ({
        url: '/payment/getcert',
        method: 'GET',
      }),
    }),
    sendPay: build.mutation<PaymentType, { url: string; values: PaymentRequestType }>({
      query: (data) => ({
        url: `${data.url}/processing`,
        method: 'POST',
        body: data.values,
      }),
    }),
    getCalcComiss: build.mutation<PaymentType, PaymentRequestType>({
      query: (data) => ({
        url: '/invoice/calcomiss',
        method: 'POST',
        body: data,
      }),
    }),
    sendCheck: build.mutation<PaymentType, { ID: string; check: { ID: string; email: string } }>({
      query: ({ ID, check }) => ({
        url: `/sendcheck_test?id=${ID}`,
        method: 'POST',
        body: check,
      }),
    }),
    getStatusPayment: build.query<PaymentType, string | number>({
      query: (id) => ({
        url: `/payment/check?id=${id}&json`,
        method: 'POST',
      }),
    }),
    validateMerchant: build.mutation<ValidateMerchantResponse, ValidateMerchantRequest>({
      // for ApplePay
      query: (data) => ({
        url: '/applepay/validate',
        method: 'POST',
        body: data,
      }),
    }),
    retryPayment: build.query<PaymentType, string>({
      query: (ID) => ({
        url: `/payment/recreate?id=${ID}`,
        method: 'GET',
        responseHandler: 'text',
      }),
    }),
  }),
});

export const {
  useGetDataQuery,
  useLazyGetDataQuery,
  useGetCertQuery,
  useSendPayMutation,
  useGetCalcComissMutation,
  useSendCheckMutation,
  useGetStatusPaymentQuery,
  useValidateMerchantMutation,
  useLazyRetryPaymentQuery,
} = paymentService;
